import React from "react";
import { MenuList, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import menus from "./data";

const MenuListItems = ({ list }) => {
  return (
    <MenuList sx={{ bgcolor: "background.paper", borderRadius: 2, p: 1 }}>
      {list.map((item) => (
        <MenuItem key={item.to} sx={{ pl: item.children ? 2 : 1 }}>
          <Link
            to={item.to || "#"}
            style={{ textDecoration: "none", color: "inherit", width: "100%" }}
          >
            {item.label}
          </Link>
          {item.children && <MenuListItems list={item.children} />}
        </MenuItem>
      ))}
    </MenuList>
  );
};

export default function Treeview({ menus = [] }) {
  return (
    <div style={{ maxWidth: 300, padding: 16 }}>
      <h2 style={{ fontSize: "18px", marginBottom: 12 }}>Nested Menu</h2>
      <MenuListItems list={menus} />
    </div>
  );
}
